import { render, staticRenderFns } from "./cargarArchivo.vue?vue&type=template&id=225787ad&scoped=true"
import script from "./cargarArchivo.vue?vue&type=script&lang=js"
export * from "./cargarArchivo.vue?vue&type=script&lang=js"
import style0 from "./cargarArchivo.vue?vue&type=style&index=0&id=225787ad&prod&scoped=true&lang=css"
import style1 from "./cargarArchivo.vue?vue&type=style&index=1&id=225787ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225787ad",
  null
  
)

export default component.exports